import React from "react";
import { DatePicker } from "antd";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Checkbox,
  Tooltip,
} from "antd";
import { DatePickerY, Styled } from "../../pageStyled";
import Iconmoon from "../../../Components/IconsFiles/icon";
import moment from "moment";
export default function soValidation({input,index,onPoDateChange,redirectToViewOrders,offset,loadings,resendAppLoading}) {
  return (
    <Row
      gutter={[10, 10]}
      className="groupForm"
      style={{
        width: "2000px",
        marginBottom: "10px",
        paddingBottom: "10px",
      }}
    >
      <Col style={{ paddingTop: "40px" }}>
        <Styled>
          {/* {(input.error_count || input.errors.hasOwnProperty(input)) && */}
          <Tooltip
            placement="bottomRight"
            title={
              input.error_count || Object.keys(input.errors).length > 0
                ? "This SO has failed validation"
                : input.isPOSaved
                ? "This SO is saved"
                : ""
            }
            className="edit-tooltip"
            getPopupContainer={(triggerNode) => triggerNode}
          >
            <div style={{ cursor: "default" }}>
              <Iconmoon
                icon={
                  input.error_count || Object.keys(input.errors).length > 0
                    ? "wrong"
                    : input.isPOSaved
                    ? "correct"
                    : ""
                }
                size={14}
                color={
                  input.error_count || Object.keys(input.errors).length > 0
                    ? "#EA655B"
                    : input.isPOSaved
                    ? "#3FBD61"
                    : ""
                }
              />
            </div>
          </Tooltip>
          {/* } */}
        </Styled>
      </Col>
      <Col span={1}>
        <div className="boxFormType">
          <Form.Item
            label="S.No."
            name={`sno${offset + index}`}
            rules={[]}
            className="dBlock"
            initialValue={offset + (index + 1)}
          >
            <Input disabled style={{ textTransform: "capitalize" }} />
          </Form.Item>
        </div>
      </Col>
      <Col span={2}>
            <div className="boxFormType">
              <Form.Item
                label="SO REF. Number"
                name={`poNumber${offset + index}`}
                rules={[
                  {
                    required: true,
                    message: "PO number is required",
                  },
                ]}
                className="dBlock"
                initialValue={input.po.number}
                validateStatus={
                  input.errors.hasOwnProperty("number") ? "error" : null
                }
                // help={input.errors.hasOwnProperty('number') ? input.errors.number : null}
              >
                <Input
                  disabled
                  placeholder=""
                  onChange={''}
                  style={{ textTransform: "capitalize" }}
                />
              </Form.Item>
            </div>
            {input.errors.hasOwnProperty("number") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {input.errors.number}
              </span>
            ) : null}
          </Col>
      <Col style={{ width: "140px" }}>
        <DatePickerY>
          <Form.Item
            label="SO Date"
            name={`PODate${offset + index}`}
            rules={[
              {
                required: true,
                message: "This field is required",
              },
            ]}
            className="dBlock"
            initialValue={
              input.errors.hasOwnProperty("date")
                ? ""
                : input.po.date
                ? moment(input.po.date)
                : null
            }
            validateStatus={
              input.errors.hasOwnProperty("date") ? "error" : null
            }
            //help={input.errors.hasOwnProperty('date') ? input.errors.date : null}
          >
            <DatePicker
              placeholder="Select date"
              format={"DD/MM/YYYY"}
              Cannot
              select
              days
              before
              today
              for
              SO
              date
              disabledDate={(current) => {
                return current && current < moment().subtract(1, "day");
              }}
              onChange={() => onPoDateChange(offset + index, input)}
              disabled={
                input.isPOSaved
                  ? true
                  : loadings || resendAppLoading
                  ? true
                  : false
              }
            />
          </Form.Item>
        </DatePickerY>
        {input.errors.hasOwnProperty("date") ? (
          <span className="errorText" style={{ color: "#ea4e2c" }}>
            {input.errors.date}
          </span>
        ) : null}
      </Col>
      <Col span={3}>
        <div className="boxFormType">
          <Form.Item
            label="Customer"
            name={`customer${offset + index}`}
            rules={[
              {
                required: false,
                message: "This field is required",
              },
            ]}
            className="dBlock"
            initialValue={''}
            
            // help={input.errors.hasOwnProperty('customer') ? input.errors.customer : null}
          >
            <Select
              showSearch
              name="customer"
              placeholder="Select Customer"
              disabled={
                true
              }
            >
            </Select>
          </Form.Item>
        </div>
        {/* <Form.Item name={`deliverToCustomer${offset + index}`}>
          <GlobalSet>
            <div className="checklist-address">
              <Checkbox
                type="checkbox"
                value={input.po.deliverToCustomer}
                onChange={(e) => onDeliverToCustomer(e, offset + index)}
                //  defaultChecked={
                //   input.po.deliverToCustomer
                // }
                checked={input.po.deliverToCustomer ? true : false}
                // disabled={!customer}
                //name = {`deliverToCustomer${index}`}
                // checked = {input.po.deliverToCustomer}
              />
              <p
                style={{
                  fontSize: "14px",
                  fontStyle: "normal",
                  lineHeight: "20px",
                  fontFamily: "var(--sf-pro-text)",
                  color: "var(--para-text)",
                  margin: "0",
                }}
              >
                Deliver to this customer
              </p>
            </div>
          </GlobalSet>
        </Form.Item>
        <Form.Item name={`shipToCustomer${offset + index}`}>
          <GlobalSet>
            <div className="checklist-address">
              <Checkbox
                type="checkbox"
                value={input.po.shipToCustomer}
                onChange={(e) => onShipToCustomer(e, offset + index)}
                // disabled={!customer}
                checked={input.po.shipToCustomer}
              />
              <p
                style={{
                  fontSize: "14px",
                  fontStyle: "normal",
                  lineHeight: "20px",
                  fontFamily: "var(--sf-pro-text)",
                  color: "var(--para-text)",
                  margin: "0",
                }}
              >
                Ship to this customer
              </p>
            </div>
          </GlobalSet>
        </Form.Item>
        <Form.Item>
          <GlobalSet>
            <div className="checklist-address">
              <Checkbox
                type="checkbox"
                // value={checkedBox}
                onChange={(e) => onBillToCustomer(e, offset + index)}
                // disabled={!customer}
                checked={input.po.billToCustomer}
              />
              <p
                style={{
                  fontSize: "14px",
                  fontStyle: "normal",
                  lineHeight: "20px",
                  fontFamily: "var(--sf-pro-text)",
                  color: "var(--para-text)",
                  margin: "0",
                }}
              >
                Bill to this customer
              </p>
            </div>
          </GlobalSet>
        </Form.Item> */}
      </Col>
      <Col span={3}>
        <div className="boxFormType">
          <Form.Item
            label="Consignee"
            name={`consignee${offset + index}`}
            rules={[
              {
                required: false,
                message: "This field is required",
              },
            ]}
            className="dBlock"
            initialValue={''}
            // help={input.errors.hasOwnProperty('customer') ? input.errors.customer : null}
          >
            <Select
              showSearch
              name="consignee"
              
              onChange={() => ''}
              placeholder="Select consignee"
              disabled={
                true
              }
            >
            </Select>
          </Form.Item>
        </div>
        {/* <FormItem>
          <GlobalSet>
            <div className="checklist-address">
              <Checkbox
                type="checkbox"
                //value={checkedBox}
                onChange={(e) => onDeliverToConsignee(e, offset + index)}
                // disabled={!customer}
                checked={input.po.deliverToConsignee}
              />
              <p
                style={{
                  fontSize: "14px",
                  fontStyle: "normal",
                  lineHeight: "20px",
                  fontFamily: "var(--sf-pro-text)",
                  color: "var(--para-text)",
                  margin: "0",
                }}
              >
                Deliver to this consignee
              </p>
            </div>
          </GlobalSet>
        </FormItem>
        <FormItem>
          <GlobalSet>
            <div className="checklist-address">
              <Checkbox
                type="checkbox"
                // value={checkedBox}
                onChange={(e) => onShipToConsignee(e, offset + index)} // disabled={!customer}
                checked={input.po.shipToConsignee}
              />
              <p
                style={{
                  fontSize: "14px",
                  fontStyle: "normal",
                  lineHeight: "20px",
                  fontFamily: "var(--sf-pro-text)",
                  color: "var(--para-text)",
                  margin: "0",
                }}
              >
                Ship to this consignee
              </p>
            </div>
          </GlobalSet>
        </FormItem>
        <FormItem>
          <GlobalSet>
            <div className="checklist-address">
              <Checkbox
                type="checkbox"
                // value={checkedBox}
                onChange={(e) => onBillToConsignee(e, offset + index)} // disabled={!customer}
                checked={input.po.billToConsignee}
              />
              <p
                style={{
                  fontSize: "14px",
                  fontStyle: "normal",
                  lineHeight: "20px",
                  fontFamily: "var(--sf-pro-text)",
                  color: "var(--para-text)",
                  margin: "0",
                }}
              >
                Bill to this consignee
              </p>
            </div>
          </GlobalSet>
        </FormItem> */}
      </Col>
      <Col span={3}>
        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
          <Col span={24}>
            <div className="boxFormType">
              <Form.Item
                label="Delivery Address"
                name={`delivery_address_line_1${offset + index}`}
                rules={[
                  {
                    required: false,
                  },
                ]}
                className="dBlock"
                initialValue={''}
              >
                <Input
                  disabled={
                    true
                  }
                  placeholder={"First Line of address"}
                  style={{ textTransform: "capitalize" }}
                />
              </Form.Item>
            </div>
          </Col>
        </Row>
        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
          <Col span={24}>
            <div className="boxFormType">
              <Form.Item
                name={`delivery_address_line_2${offset + index}`}
                rules={[
                  {
                    max: 50,
                    message: "Name can have a maximum of 50 characters",
                  },
                ]}
                className=""
                initialValue={''}
              >
                <Input
                  disabled={true
                  }
                  placeholder={"Second Line of address"}
                  style={{ textTransform: "capitalize" }}
                  
                />
              </Form.Item>
            </div>
          </Col>
        </Row>
        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
          <Col span={12}>
            <div className="boxFormType">
              <Form.Item
                name={`delivery_country${offset + index}`}
                rules={[
                  {
                    required: false,
                  },
                ]}
                className=""
                initialValue={''}
              >
                <Select
                  className="disabled-check"
                  
                  disabled={true
                  }
                  
                  placeholder="Country"
                  
                  //onChange={handleProvinceChange}
                >
                </Select>
              </Form.Item>
            </div>
          </Col>
          <Col span={12}>
            <div className="boxFormType">
              <Form.Item
                name={`delivery_state${offset + index}`}
                rules={[
                  {
                    required: false,
                  },
                ]}
                className=""
                initialValue={''}
              >
                <Select
                  placeholder={"State"}
                  disabled={true
                  }
                  
                >
                  
                </Select>
              </Form.Item>
            </div>
          </Col>
        </Row>
        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
          <Col span={12}>
            <div className="boxFormType">
              <Form.Item
                name={`delivery_city${offset + index}`}
                rules={[
                  {
                    required: false,
                  },
                  
                ]}
                className=""
                initialValue={''}
              >
                <Input
                  disabled={
                    true
                  }
                  placeholder="City"
                  style={{ textTransform: "capitalize" }}
                />
              </Form.Item>
            </div>
          </Col>
          <Col span={12}>
            <div className="boxFormType">
              <Form.Item
                name={`delivery_pincode${offset + index}`}
                rules={[
                  {
                    required: false,
                    
                  },
                  
                ]}
                className=""
                initialValue={''}
              >
                <Input
                  disabled={
                    true
                  }
                  placeholder="Pin Code"
                  style={{ textTransform: "capitalize" }}
                  
                />
              </Form.Item>
            </div>
          </Col>
        </Row>
      </Col>
      <Col span={3}>
        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
          <Col span={24}>
            <div className="boxFormType">
              <Form.Item
                label="Shipping Address"
                name={`shipping_address_line_1${offset + index}`}
                rules={[
                  {
                    required: false,
                    message: "This field is required",
                  },
                  
                ]}
                className="dBlock"
                initialValue={''}
              >
                <Input
                  disabled={true
                  }
                  placeholder={"First Line of address"}
                  style={{ textTransform: "capitalize" }}
                />
              </Form.Item>
            </div>
          </Col>
        </Row>
        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
          <Col span={24}>
            <div className="boxFormType">
              <Form.Item
                name={`shipping_address_line_2${offset + index}`}
                rules={[
                  
                ]}
                className=""
                initialValue={''}
              >
                <Input
                  disabled={true
                  }
                  placeholder={"Second Line of address"}
                  style={{ textTransform: "capitalize" }}
                />
              </Form.Item>
            </div>
          </Col>
        </Row>
        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
          <Col span={12}>
            <div className="boxFormType">
              <Form.Item
                name={`shipping_country${offset + index}`}
                rules={[
                  {
                    required: false,
                    message: "This field is required",
                  },
                 
                ]}
                className=""
                initialValue={''}
              >
                <Select
                  className="disabled-check"
                  
                  disabled={
                   true
                  }
                  
                  placeholder="Country"
                >
                </Select>
              </Form.Item>
            </div>
          </Col>
          <Col span={12}>
            <div className="boxFormType">
              <Form.Item
                name={`shipping_state${offset + index}`}
                rules={[
                  {
                    required: false,
                    message: "This field is required",
                  },
                 
                ]}
                className=""
                initialValue={''}
                
              >
                <Select
                  
                  placeholder={"State"}
                  disabled={
                   true
                  }
                  
                >
                  
                </Select>
              </Form.Item>
            </div>
          </Col>
        </Row>
        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
          <Col span={12}>
            <div className="boxFormType">
              <Form.Item
                name={`shipping_city${offset + index}`}
                rules={[
                  {
                    required: false,
                    message: "This field is required",
                  },
                ]}
                className=""
                initialValue={''}
                
              >
                <Input
                  disabled={true
                  }
                  placeholder="City"
                  style={{ textTransform: "capitalize" }}                  
                />
              </Form.Item>
            </div>
          </Col>
          <Col span={12}>
            <div className="boxFormType">
              <Form.Item
                name={`shipping_pincode${offset + index}`}
                rules={[
                  {
                    required: false,
                    
                  }
                ]}
                className=""
                initialValue={''}
              >
                <Input
                  disabled={
                    true
                  }
                  placeholder="Pin Code"
                  style={{ textTransform: "capitalize" }}
                />
              </Form.Item>
            </div>
          </Col>
        </Row>
      </Col>
      <Col span={3}>
        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
          <Col span={24}>
            <div className="boxFormType">
              <Form.Item
                label="Billing Address"
                name={`billing_address_line_1${offset + index}`}
                rules={[
                  {
                    required: false,
                    message: "This field is required",
                  }
                ]}
                className="dBlock"
                initialValue={''}
              >
                <Input
                  disabled={true
                  }
                  placeholder={"First Line of address"}
                  style={{ textTransform: "capitalize" }}
                />
              </Form.Item>
            </div>
          </Col>
        </Row>
        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
          <Col span={24}>
            <div className="boxFormType">
              <Form.Item
                name={`billing_address_line_2${offset + index}`}
                className=""
                initialValue={''}
              >
                <Input
                  disabled={true
                  }
                  placeholder={"Second Line of address"}
                  style={{ textTransform: "capitalize" }}
                />
              </Form.Item>
            </div>
          </Col>
        </Row>
        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
          <Col span={12}>
            <div className="boxFormType">
              <Form.Item
                name={`billing_country${offset + index}`}
                rules={[
                  {
                    required: false,
                    message: "This field is required",
                  }
                ]}
                className=""
                initialValue={''}
              >
                <Select
                  className="disabled-check"
                  disabled={true
                  }
                  
                  placeholder="Country"
                  
                  //onChange={handleProvinceChange}
                >
                </Select>
              </Form.Item>
            </div>
          </Col>
          <Col span={12}>
            <div className="boxFormType">
              <Form.Item
                name={`billing_state${offset + index}`}
                rules={[
                  {
                    required: false,
                    message: "This field is required",
                  },
                  {
                    max: 50,
                    message: "Name can have a maximum of 50 characters",
                  },
                ]}
                className=""
                initialValue={''}
              >
                <Select
                  placeholder={"State"}
                  disabled={
                  true}
                  
                >
                  
                </Select>
              </Form.Item>
            </div>
          </Col>
        </Row>
        <Row gutter={[10, 10]} style={{ marginBottom: "5px" }}>
          <Col span={12}>
            <div className="boxFormType">
              <Form.Item
                name={`billing_city${offset + index}`}
                rules={[
                  {
                    required: false,
                    message: "This field is required",
                  }
                ]}
                className=""
                initialValue={''}
            
              >
                <Input
                  disabled={true
                  }
                  placeholder="City"
                  style={{ textTransform: "capitalize" }}
                  
                />
              </Form.Item>
            </div>
          </Col>
          <Col span={12}>
            <div className="boxFormType">
              <Form.Item
                name={`billing_pincode${offset + index}`}
                rules={[
                  {
                    required: false,
                    message: "This field is required",
                  }
                ]}
                className=""
                initialValue={''}
              >
                <Input
                  disabled={true
                  }
                  placeholder="Pin Code"
                  style={{ textTransform: "capitalize" }}
                />
              </Form.Item>
            </div>
          </Col>
        </Row>
      </Col>
      <Col span={2}>
        <Row>
          <Form.Item
            label="Order Summary"
            name={`orderSummary${offset + index}`}
            className="dBlock"
          >
            Failed Orders :{" "}
            {input.orders.filter((e) => e.error_count > 0).length}
          </Form.Item>
        </Row>
        <Row>
          <Form.Item name="orderSummary" className="dBlock">
            Verified Orders :{" "}
            {input.orders.filter((e) => e.error_count == 0).length}
          </Form.Item>
        </Row>
      </Col>
      <Col span={1}>
        <div className="boxFormType">
          <Form.Item
            label="Action"
            name={`action${offset + index}`}
            rules={[]}
            className="dBlock"
          >
            <Button
              key="3"
              className="textTypeBtn"
              disabled={loadings || resendAppLoading}
              onClick={() => redirectToViewOrders(offset + index, input)}
            >
              View Orders
            </Button>
          </Form.Item>
        </div>
      </Col>
    </Row>
  );
}
